import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import {IStateType} from "../../../../store/models/root.interface";

import {
	closeSideBar,
	getParams
} from "../../../../store/sidebar";
import Modal, { MapDispatchToPropsType, MapStateToPropsType } from '../organisms/RenameACL';
import {updateObjects} from "../../../../store/Objects";
import {InstanceAPIs, Instances} from "../../../../constants";

const mapStateToProps = (state: IStateType) => {
	const params = getParams(state);
	return (state: IStateType) => ({
		params,
	});
};
const mapDispatchToProps = {
	onClose: () => closeSideBar([]),
};

export default connect<
	MapStateToPropsType,
	MapDispatchToPropsType,
	unknown,
	IStateType
	>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(Modal));
